import React from 'react';
import { reportError } from '../lib/errorReporter';
import { TRANSLATION_MAPS } from '../i18n';

// Rendered outside the normal tree when something crashed, so it reads the
// interface language straight from storage instead of the locale context.
function tr(key) {
  try {
    const map = TRANSLATION_MAPS[localStorage.getItem('locale')];
    return (map && map[key]) || key;
  } catch {
    return key;
  }
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info);
    reportError({ kind: 'react', error, componentStack: info && info.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
          padding: 32,
          textAlign: 'center',
        }}>
          <h1 style={{ fontSize: 24, marginBottom: 8, color: '#ef4444' }}>
            {tr('Something went wrong')}
          </h1>
          <p style={{ color: '#888', marginBottom: 24, maxWidth: 480 }}>
            {this.state.error?.message || tr('An unexpected error occurred.')}
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            style={{
              padding: '10px 24px',
              borderRadius: 8,
              border: '1px solid #444',
              background: '#6366f1',
              color: '#fff',
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            {tr('Reload page')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
